export class ListDataCatalogsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListDataCatalogsFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortDataCatalogBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
